import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m5.207 3.488.024.009 15.04 5.399c.273.098.514.184.696.268.163.074.427.208.573.476.169.31.174.685.013 1-.139.271-.4.412-.56.49-.18.09-.419.182-.69.287l-6.334 2.464-.064.025-.025.063-2.463 6.335c-.105.27-.198.51-.287.69-.079.16-.22.42-.49.559-.316.16-.69.156-1-.013-.268-.146-.402-.41-.477-.573a9.65 9.65 0 0 1-.268-.696L3.496 5.231l-.008-.024a7.47 7.47 0 0 1-.195-.59c-.042-.16-.093-.409-.004-.665.108-.31.352-.555.663-.663.256-.088.504-.038.665.004.167.043.37.116.59.195Z"
      clip-rule="evenodd"
    />
  </svg>
`;
